    <router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/error' || location == '/coming-soon' || location == '/login' || location == '/register')"></app-footer>